import {
  PutTestScheduleRequestBodyType,
  PutTestScheduleResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { scheduleKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const putTestSchedule = async (
  data: ApiRequest<PutTestScheduleRequestBodyType>
) => {
  const resp = await api.put<PutTestScheduleResponseBodyType>(
    `/v2/schedules/experiences`,
    data.body
  );
  return resp.data;
};

export const usePutTestSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation<
    PutTestScheduleResponseBodyType,
    Error,
    ApiRequest<PutTestScheduleRequestBodyType>,
    any
  >({
    mutationFn: async (data: ApiRequest<PutTestScheduleRequestBodyType>) =>
      putTestSchedule(data),
    onSuccess: async (data, payload) => {
      queryClient.setQueryData(
        scheduleKeys.one(payload.body.experienceId),
        data
      );
    },
  });
};
